import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../hooks/useSEO";
import ScoringGuide from "../components/ScoringGuide";

export default function About() {
  useSEO({
    title: "About",
    description: "Predict90 is a free football score-prediction league. Pick the score before lock. 5 for exact.",
    keywords: "football predictions, prediction league, Predict90, about",
  });

  return (
    <div className="min-h-screen bg-paper text-ink">
      <div className="mx-auto max-w-2xl px-4 py-10 md:px-6 md:py-14">
        <p className="text-meta font-semibold text-brand">Predict90</p>
        <h1 className="mt-1 text-[28px] font-bold leading-tight md:text-[32px]">
          Call the score. Beat your mates.
        </h1>
        <p className="mt-4 text-[15px] leading-relaxed text-muted">
          A small football prediction league. You pick the score before it locks — usually 30 minutes
          before kickoff. Exact is 5 points. Right goal difference or a correct draw is 3. Right
          result is 2. One team&apos;s score is 1.
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-muted">
          Premier League, Champions League, and the other top leagues. No betting, no stakes — just
          the table after full-time.
        </p>

        <div className="mt-8">
          <ScoringGuide />
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <Link
            to="/auth"
            className="inline-flex h-11 items-center rounded-lg bg-brand px-4 text-[15px] font-semibold text-white hover:bg-brand-hover"
          >
            Join for free
          </Link>
          <a
            href="https://discord.gg/jGpvZqNRFj"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-11 items-center rounded-lg border border-line bg-white px-4 text-[15px] font-semibold text-ink hover:border-gray-400"
          >
            Discord
          </a>
        </div>
      </div>
    </div>
  );
}
